import { getService } from 'data/function';
export class StateProcessor {
    static get $state() {
        return getService('$state');
    }
    /**
     * Process state event action from postMessage
     */
    static process({ message }) {
        const params = message.content.params;
        const method = message.content.method;
        if (typeof params === 'object') {
            StateProcessor.$state[method](...params);
        }
        else {
            StateProcessor.$state[method](params);
        }
    }
}
